<template>
  <div>
    <sameday-times
      :settings="settings"
      :times="times"
      @on:form="$emit('on:form', $event)"
    ></sameday-times>
  </div>
</template>

<script>
import { getToday } from "@/moment-tz.js";
import SamedayTimes from "@/components/Sameday/SamedayTimes.vue";

export default {
  components: {
    SamedayTimes,
  },
  props: {
    settings: {
      type: Object,
      default: () => {},
    },
    availabilities: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    timezone() {
      return this.settings?.timezone;
    },
    today() {
      return getToday(this.timezone)[1];
    },
    availability() {
      if (!this.availabilities) return;
      return (this.availabilities || [])?.find((el) => el?.date === this.today);
    },
    times() {
      if (!this.availability) return [];
      return (this.availability || [])?.times?.map((el) => {
        return {
          ...el,
          date: this.availability?.date || [],
        };
      });
    },
  },
};
</script>
